import React, { FunctionComponent } from "react";

import { bemClassNames, createQA } from "@multiweb/reactUtils";
import { WorkflowEditorProps } from "../../types";
import { PropertyPanel } from "./PropertyPanel";

const classNames = bemClassNames("wf-editor-property-panel");
const wfPropertyCardStyle = classNames();

const wfEditorPropertyPanelDataQA = createQA("wf-editor-property-panel");

export const PropertyPanelContainer: FunctionComponent<WorkflowEditorProps> = ({ hostKey }) => (
    <div {...wfEditorPropertyPanelDataQA} className={wfPropertyCardStyle}>
        <PropertyPanel {...{ hostKey }} />
    </div>
);
